export default "__VITE_ASSET__71Jcn8Wr__"